import React from 'react';
import Icon from '../../../components/AppIcon';

const HiringStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Applications',
      value: stats?.totalApplications || 0,
      change: '+18',
      changeType: 'increase',
      icon: 'FileText',
      color: 'primary'
    },
    {
      title: 'Active Interviews',
      value: stats?.activeInterviews || 0,
      change: '+5',
      changeType: 'increase',
      icon: 'Users',
      color: 'secondary'
    },
    {
      title: 'Pending Verification',
      value: stats?.pendingVerification || 0,
      change: '-3',
      changeType: 'decrease',
      icon: 'Clock',
      color: 'warning'
    },
    {
      title: 'Onboarding in Progress',
      value: stats?.onboardingInProgress || 0,
      change: '+2',
      changeType: 'increase',
      icon: 'UserCheck',
      color: 'accent'
    },
    {
      title: 'Placed Veterans',
      value: stats?.placedVeterans || 0,
      change: '+12',
      changeType: 'increase',
      icon: 'Award',
      color: 'success'
    },
    {
      title: 'Clearance Verified',
      value: stats?.clearanceVerified || 0,
      change: '+8',
      changeType: 'increase',
      icon: 'Shield',
      color: 'error'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary': return 'text-primary bg-primary/10 border-primary/20';
      case 'success': return 'text-success bg-success/10 border-success/20';
      case 'warning': return 'text-warning bg-warning/10 border-warning/20';
      case 'error': return 'text-error bg-error/10 border-error/20';
      case 'secondary': return 'text-secondary bg-secondary/10 border-secondary/20';
      case 'accent': return 'text-accent bg-accent/10 border-accent/20';
      default: return 'text-muted-foreground bg-muted/10 border-muted/20';
    }
  };

  const getChangeColor = (changeType) => {
    switch (changeType) {
      case 'increase': return 'text-success';
      case 'decrease': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getChangeIcon = (changeType) => {
    switch (changeType) {
      case 'increase': return 'TrendingUp';
      case 'decrease': return 'TrendingDown';
      default: return 'Minus';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="glass-container rounded-xl border border-border/50 p-6 hover:shadow-glass-lg transition-all duration-200"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center border ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className="flex items-center space-x-1">
              <Icon 
                name={getChangeIcon(stat?.changeType)} 
                size={16} 
                className={getChangeColor(stat?.changeType)}
              />
              <span className={`text-sm font-medium ${getChangeColor(stat?.changeType)}`}>
                {stat?.change}
              </span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">
              {typeof stat?.value === 'number' ? stat?.value?.toLocaleString() : stat?.value}
            </h3>
            <p className="text-sm text-muted-foreground">{stat?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HiringStats;